import React from 'react'
import { ModalWrapper, Reoverlay } from 'reoverlay'
import AcquiaForm from 'components/Contact/AcquiaForm'
// eslint-disable-next-line no-unused-vars

import 'reoverlay/lib/ModalWrapper.css'

const InquireModal = ({ modalSubmit, isSent, resetForm }) => {
  const closeModal = () => {
    Reoverlay.hideModal()
  }

  const formID = process.env.GATSBY_ACS_FORM_ID

  return (
    <ModalWrapper
      contentContainerClassName="modal-content"
      wrapperClassName="modal__wrapper"
      onClose={() => Reoverlay.hideModal()}
      animation="slideUp"
    >
      <AcquiaForm id={formID} modalSubmit={modalSubmit} resetForm={resetForm} isSent={isSent} />
      {/* <BlockHtml content={content} />
      <ContactForm modalSubmit={modalSubmit} resetForm={resetForm} isSent={isSent} /> */}
      <button className="close-modal" type="button" onClick={closeModal}>
        Close modal
      </button>
    </ModalWrapper>
  )
}
export default InquireModal
